import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Home extends Component {
    render() {
        return (
            <div>
                <hr />
                {/* About Section */}
                <section className="section about-page py-5">
                    <div className="container text-center">
                        <div className="row align-items-center">
                            <div className="col-lg-4 mb-4 d-flex justify-content-center justify-content-lg-start">
                                <img src="images/about/about-5.jpg" alt="Matrimonial" className="img-fluid rounded shadow" />
                            </div>
                            <div className="col-lg-8">
                                <h2 className="title-color">Why Varenya Matrimonial?</h2>
                                <p className="mt-3">
                                    We are committed to nurturing lifelong connections through verified profiles, tailored matchmaking,
                                    and cultural alignment. Our platform ensures a safe and meaningful search for your ideal life partner.
                                </p>
                                <p className="mt-3">We are a verified Brahmin-only community offering personalized match suggestions along with friendly support and guidance.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* How It Works */}
                <section className="section bg-light py-5">
                    <div className="container text-center">
                        <h2 className="mb-5">How It Works</h2>
                        <div className="row">
                            {[
                                { icon: '📝', title: '1. Register', desc: 'Create your profile by calling our Admin.' },
                                { icon: '🔍', title: '2. Search & Connect', desc: 'Browse verified matches tailored to your preferences.' },
                                { icon: '💬', title: '3. Interact', desc: 'Start meaningful conversations and build a bond.' },
                                { icon: '💍', title: '4. Marriage', desc: 'Find your soulmate and begin your journey together.' }
                            ].map((step, idx) => (
                                <div key={idx} className="col-md-3 mb-4">
                                    <div className="p-4 border rounded shadow-sm h-100">
                                        <div style={{ fontSize: '36px' }}>{step.icon}</div>
                                        <h5 className="mt-3">{step.title}</h5>
                                        <p className="text-muted">{step.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Call to Action */}
                <section className="section text-center py-5">
                    <div className="container">
                        <h2 className="mb-4">Start Your Journey Today</h2>
                        <p className="mb-4">Join hundreds of Brahmin singles finding genuine companionship through Varenya Matrimonial.</p>
                        <Link to="/contact" className="btn btn-main btn-round-full mx-2">Register Now</Link>
                        <Link to="/pricing" className="btn btn-main btn-round-full mx-2" style={{ background: "black" }}>View Pricing</Link>
                    </div>
                </section>
            </div>
        );
    }
}
